// Polyfill foreach for Node.
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

import navigation from './vendor/10up-nav';

/**
 * Primary navigation.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function() {
	const container = document.getElementById( 'js-header-menu' );

	// Bail if there is no menu.
	if ( ! container ) {
		return;
	}

	const button = document.getElementById( 'js-header-menu-toggle' );
	const menuHeader = document.getElementById( 'header-menu__items' );

	new navigation( '#header-menu__items', {
		action: 'click',
		breakpoint: '(min-width: 1075px)',
		/**
		 * On create.
		 */
		onCreate: function() {
		},
		/**
		 * On open.
		 */
		onOpen: function() {
			container.classList.add( 'is-opened' );
			menuHeader.classList.add( 'is-opened' );
			button.classList.add( 'is-opened' );
		},
		/**
		 * On close.
		 */
		onClose: function() {
			container.classList.remove( 'is-opened' );
			menuHeader.classList.remove( 'is-opened' );
			button.classList.remove( 'is-opened' );
		},
		/**
		 * On sub menu open.
		 */
		onSubmenuOpen: function() {
		},
		/**
		 * On sub menu close.
		 */
		onSubmenuClose: function() {
		}
	} );

})();
